import React, { useCallback, useMemo, useState } from 'react';

import { SUBCATEGORIES } from '../../common/categories';
import * as actions from '../../containers/Integrations/integrationsActions';

import PingFedApp from './PingFedApp';
import ArrayContainer from '../Controls/ArrayContainer/ArrayContainer';
import Button from '../Controls/Button/Button';
import ImportPingFedRelyingParties from './ImportPingFedRelyingParties';
import { SettingsFeatureLock } from '../LockedFeatures/SettingsFeatureLock';
import { useGetTabDisplay } from '../../hooks/lockedFeatures/useTabDisplay';

const { PING_FEDERATED_APPS } = SUBCATEGORIES;

const PingFedApps = ({ fields, dispatch, authorizePermission }) => {
    const [showImportModal, setShowImportModal] = useState(false);
    const { enabled } = useGetTabDisplay(PING_FEDERATED_APPS.ID);

    const disabled = useMemo(() => !authorizePermission || !enabled, [authorizePermission, enabled]);
    const pingFedApps = fields[PING_FEDERATED_APPS.ID];

    const toggleImportPopup = useCallback(() => {
        setShowImportModal(!showImportModal);
    }, [showImportModal, setShowImportModal]);

    const dispatchAdd = useCallback(() => {
        dispatch({ type: actions.ADD_PINGFED_APP });
    }, [dispatch]);

    const dispatchUpdate = useCallback(
        (index, fieldId, value) => {
            dispatch({
                type: actions.UPDATE_PINGFED_APP,
                payload: { index, arrFieldId: fieldId, value }
            });
        },
        [dispatch]
    );

    const dispatchRemove = useCallback(
        (index) => {
            dispatch({ type: actions.REMOVE_PINGFED_APP, payload: index });
        },
        [dispatch]
    );

    const onImport = useCallback(
        (pingFedApps) => {
            dispatch({ type: actions.ADD_MULTIPLE_PINGFED_APPS, payload: pingFedApps });
        },
        [dispatch]
    );

    return (
        <>
            {pingFedApps.value.map((app, index) => {
                return (
                    <ArrayContainer
                        key={PING_FEDERATED_APPS.ID + index}
                        header="PingFed App"
                        remove={() => !disabled && authorizePermission && dispatchRemove(index)}>
                        <PingFedApp
                            pingFedApp={app}
                            changedFunc={(fId, v) => dispatchUpdate(index, fId, v)}
                            disabled={disabled}
                        />
                    </ArrayContainer>
                );
            })}

            <div style={{ marginTop: `${pingFedApps.value.length === 0 ? '30px' : '0'}` }}>
                <SettingsFeatureLock id={PING_FEDERATED_APPS.ID} isTabId={true}>
                    <Button id="ping-fed-apps-add-federated-app-btn" onClick={dispatchAdd} disabled={disabled}>
                        + Add Federated App
                    </Button>
                </SettingsFeatureLock>
                <SettingsFeatureLock id={PING_FEDERATED_APPS.ID} isTabId={true}>
                    <Button style={{ marginLeft: '30px' }} onClick={toggleImportPopup} disabled={disabled}>
                        Import From Directory
                    </Button>
                </SettingsFeatureLock>
            </div>

            {showImportModal && <ImportPingFedRelyingParties save={onImport} close={toggleImportPopup} />}
        </>
    );
};

export default React.memo(PingFedApps);
